export default __webpack_public_path__ + "static/media/img1.752317fa.jpg";